import React, { useState } from 'react'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { isAuth, signout } from '../../helpers/cookies';
import { ADMIN_PORTAL_ACCESS } from '../../helpers/constants';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setChangePasswordOpen, setMobileSearchOpen } from '../../store/user/userSlice';
import { setProfileModalOpen } from '../../store/profile/profileSlice';
import SearchOutlined from '@mui/icons-material/SearchOutlined';
import ProfileModal from './profile/ProfileModal.jsx';

let settings = ['My Profile', 'Change Password', 'Logout'];

const ToolbarAccount = () => {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { is_open, is_mobile_search_open } = useSelector((state) => state.user);
  const { currentUser } = useSelector((state) => state.auth);

  if (ADMIN_PORTAL_ACCESS.includes((currentUser?.role || isAuth()?.role))) {
    let pathname = window.location.pathname;
    if (pathname.includes('/admin')) {
      !settings.includes('Web Portal') && settings.splice(2, 0, 'Web Portal');
    }
    else {
      !settings.includes('Dashboard') && settings.splice(2, 0, 'Dashboard');
    }
  }
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleSignOut = () => {
    signout(() => navigate(0));
  };

  const handleChangePassword = () => {
    dispatch(setChangePasswordOpen(!is_open));
  };

  const handleProfileModalOpen = () => {
    dispatch(setProfileModalOpen(true));
  };

  const handleMobileSearch = () => {
    dispatch(setMobileSearchOpen(!is_mobile_search_open))
  }
  return (
    <Box sx={{ flexGrow: 0, display: 'flex', alignItems: 'center', pr: '20px' }}>
      {/* <IconButton sx={{display:{md:'none',xs:'flex'}}} onClick={handleMobileSearch}>
          <SearchOutlined />
        </IconButton> */}
      <Typography color='textPrimary' variant="subtitle2" sx={{ mr: 1, textTransform: 'capitalize', display: { md: 'flex', xs: 'none' } }}>{currentUser?.first_name || isAuth()?.first_name} {currentUser?.last_name || isAuth()?.last_name}</Typography>
      <Tooltip title="Open settings">
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0.2, border: 1, borderColor: '#D9D9D9' }}>
          <Avatar alt={currentUser?.first_name || isAuth()?.first_name} src="/static/images/avatar/2.jpg" sx={{ width: 35, height: 35, bgcolor: 'lightslategrey', textTransform: 'uppercase' }} />
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: '45px' }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {settings.map((setting) => (
          <MenuItem key={setting} onClick={handleCloseUserMenu}>
            <Typography
              sx={{ textAlign: 'left', width: '100%' }}
              {...(setting === "My Profile" && { onClick: handleProfileModalOpen })}
              {...(setting === "Dashboard" && { onClick: () => window.location.replace('/admin') })}
              {...(setting === "Web Portal" && { onClick: () => window.location.replace('/') })}
              {...(setting === "Logout" && { onClick: handleSignOut })}
              {...(setting === "Change Password" && { onClick: handleChangePassword })}
            >{setting}</Typography>
          </MenuItem>
        ))}
      </Menu>

      {/* Profile Modal Component */}
      <ProfileModal />

    </Box>
  )
}

export default ToolbarAccount;
